import { View } from 'react-native';
import { Text } from '@/components/Text';
import { styles } from './styles';

interface NoSetsProps {
  label: string;
  subLabel: string;
}

export const NoSets = ({ label, subLabel }: NoSetsProps) => {
  return (
    <View style={styles.noSetsView}>
      <Text style={styles.noSetsTitleText}>{label}</Text>
      <Text style={styles.noSetsSubtitleText}>{subLabel}</Text>
    </View>
  );
};
